module.exports = __webpack_public_path__ + "static/media/discount_type.963443f0.svg";